import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OperationsAlertType } from '../../models';
import { RideMonitoringAlertList } from '../../models/counted-lists/ride-monitoring-alert-list';

@Injectable({
  providedIn: 'root'
})
export class RideMonitoringService extends UzurvRestService {
  readonly resourceUrl = 'rideMonitoring/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  listUnresolvedRideMonitoringAlerts(
    pageNumber: number,
    pageSize: number,
    transitProgramIds: Array<number>,
    rideStatuses: Array<string>,
    operationsAlertTypeIds: Array<number>
  ): Observable<RideMonitoringAlertList> {
    return this.get<RideMonitoringAlertList>(this.resourceUrl, {
      pageNumber: pageNumber,
      pageSize: pageSize,
      transitProgramIds: transitProgramIds.length === 0 ? [-1] : transitProgramIds,
      rideStatuses: rideStatuses.length === 0 ? ['undefined'] : rideStatuses,
      operationsAlertTypeIds: operationsAlertTypeIds.length === 0 ? [-1] : operationsAlertTypeIds
    }).pipe(map(response => Deserialize(response, RideMonitoringAlertList)));
  }

  listAllOperationAlertsTypesWithRideAlertId(pageNumber: number, pageSize: number): Observable<Array<OperationsAlertType>> {
    return this.get<OperationsAlertType>(`${this.resourceUrl}operationAlertsTypes/`, {
      pageNumber: pageNumber,
      pageSize: pageSize
    }).pipe(map(response => Deserialize(response, OperationsAlertType)));
  }
}
